import { render, staticRenderFns } from "./BookTheMayorCustom.vue?vue&type=template&id=1712b665&"
import script from "./BookTheMayorCustom.vue?vue&type=script&lang=js&"
export * from "./BookTheMayorCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports